import { apis } from '../apiBase/apiBase';
export const entityReferenceApis = apis.injectEndpoints({
    endpoints: (builder) => ({
        // エンティティ参照登録API
        insertEntityReferences: builder.mutation({
            query: (params) => ({
                url: `entity-references/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        // エンティティ参照削除API
        deleteEntityReference: builder.mutation({
            query: (params) => ({
                url: `entity-references/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        // 関連先生成API
        generateRelated: builder.mutation({
            query: (params) => ({
                url: `entity-references/generate-related`,
                method: `POST`,
                body: params,
            }),
        }),
        // エンティティ参照取得API
        getEntityReferences: builder.query({
            query: (params) => ({
                url: `entity-references`,
                method: `GET`,
                params,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useInsertEntityReferencesMutation, useDeleteEntityReferenceMutation, useGenerateRelatedMutation, useGetEntityReferencesQuery, useLazyGetEntityReferencesQuery, } = entityReferenceApis;
